module.exports = __webpack_public_path__ + "img/noSearch.72221156.png";